import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  switch(event) {
    const targetTab = event.currentTarget.dataset.tab

    // Update tab buttons
    this.element.querySelectorAll('[role="tab"]').forEach(button => {
      const isActive = button.dataset.tab === targetTab

      button.classList.toggle('border-primary', isActive)
      button.classList.toggle('text-primary', isActive)
      button.classList.toggle('border-transparent', !isActive)
      button.classList.toggle('text-muted-foreground', !isActive)
      button.setAttribute('aria-selected', isActive)
    })

    // Update tab content visibility
    document.querySelectorAll('[data-tab-content]').forEach(content => {
      const shouldShow = content.dataset.tabContent === targetTab
      content.classList.toggle('hidden', !shouldShow)
    })
  }
}
